// @cloudnest/cascadia-engine — root barrel.
//
// Phase 1 exports: types + data only. Validators, appliers, scoring,
// init-game, and the engine reducer land in P2 (TDD). See the plan at
// docs/task-log/20260505-cascadia-online/01-plan.md.
//
// Engine boundary rules (per docs/guides/architecture/engine-interface.md):
// - No React, no fetch, no WebSocket.
// - No `Math.random()` inside reducers — RNG is injected as a seed via
//   `Ruleset` + `RngConfig` and frozen into ordered supply arrays at setup.
// - Validators return a `ValidationResult`; appliers are pure state→state.
// - All state is immutable; spread/clone before modifying.

export * from "./appliers";
export * from "./data/index";
export type {
  ApplyActionFailure,
  ApplyActionResult,
  ApplyActionSuccess,
} from "./engine";
export { applyAction } from "./engine";
export type { InitGameInput } from "./init-game";
export { initGame } from "./init-game";
export * from "./scoring";
export * from "./types/index";
export * from "./utils/index";
export * from "./validators";
